import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { cn } from "@/lib/cn";
import { chooseLocalizedText } from "@/lib/localizedText";
import { useLanguageStore } from "@/stores/languageStore";

interface FeatureStatusBannerProps {
  status: "connected" | "limited";
  title: string;
  description: string;
}

export function FeatureStatusBanner({
  status,
  title,
  description,
}: FeatureStatusBannerProps) {
  const Icon = status === "connected" ? CheckCircle2 : AlertTriangle;
  const language = useLanguageStore((state) => state.language);

  return (
    <div
      className={cn(
        "mb-3 rounded-[var(--radius-lg)] border p-3",
        status === "connected"
          ? "border-emerald-200 bg-emerald-50 text-emerald-800"
          : "border-amber-200 bg-amber-50 text-amber-900",
      )}
    >
      <div className="flex items-start gap-2">
        <Icon className="mt-0.5 h-4 w-4 shrink-0" />
        <div>
          <p className="text-xs font-semibold">{chooseLocalizedText(title, language)}</p>
          <p className="mt-0.5 text-xs leading-5">
            {chooseLocalizedText(description, language)}
          </p>
        </div>
      </div>
    </div>
  );
}
